/** =========================================================
 * Module: logout.directive.js
 * Logout directive
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.utils')
    .directive('logout', logout);

  logout.$inject = ['$api', '$state', 'ngDialog'];

  function logout($api, $state, ngDialog) {
    var directive = {
      restrict: 'A',
      link: link
    };

    return directive;

    function link($scope, element) {
      element.on('click', function () {
        $scope.message = 'Do you really want to logout?';

        ngDialog.openConfirm({
          template: 'app/views/dialogs/confirm.html',
          scope: $scope
        }).then(function () {
          $api.logout().then(function () {
            $state.go('login');
          });
        });
      });
    }
  }
})();
